import req from '@/utils/request';

// 获取理疗数据-开单统计
export const getPhysioBillingStatistics = (params) => {
  return req.get('/doctor/statistics/physio/order/queryPhysioStatusStatistics', params);
}

// 获取理疗数据-开单列表
export const getPhysioBillingList = (params) => {
  return req.get('/doctor/statistics/physio/order/queryPhysioStatusStatisticsData', params);
}

// 获取理疗数据-开单排名
export const getPhysioBillingRank = (params) => {
  return req.get('/doctor/statistics/physio/order/queryPhysioItemRank', params);
}

// 获取理疗数据-执行统计
export const getPhysioExecuteStatistics = (params) => {
  return req.get('/doctor/statistics/physio/order/queryPhysioReservationStatusStatistic', params);
}

// 获取理疗数据-执行列表
export const getPhysioExecuteList = (params) => {
  return req.get('/doctor/statistics/physio/order/queryPhysioReservationStatusStatisticsBaseData', params);
}

// 获取理疗数据-执行排名
export const getPhysioExecuteRank = (params) => {
  return req.get('/doctor/statistics/physio/order/queryPhysioExecuteItemRank', params);
}



//门诊数据-订单状态数据统计
export const queryOpdStatusStatistics = (params) => {
  return req.get('/doctor/statistics/opd/order/queryOpdStatusStatistics', params);
}
//门诊数据-订单数据列表
export const queryOptStatusStatisticsBaseData = (params) => {
  return req.get('/doctor/statistics/opd/order/queryOptStatusStatisticsBaseData', params);
}
//门诊数据-门诊分析
export const opdDataStatistics = (params) => {
  return req.get('/doctor/statistics/opd/order/opdDataStatistics', params);
}
//门诊数据-诊断排名
export const queryOpdDiagnosisRank = (params) => {
  return req.get('/doctor/statistics/opd/order/queryOpdDiagnosisRank', params);
}

//挂号数据-统计
export const registerOrder = (params) => {
  return req.get('/report/doctor/statistics/register/order/status', params);
}
//挂号数据-明细列表
export const registerList = (params) => {
  return req.get('/report/doctor/statistics/register/order/status/list', params);
}
// 挂号数据-门诊号源预约时间
export const registerTime = (params) => {
  return req.get('/report/doctor/statistics/register/order/appointment/time', params);
}
// 挂号数据-统计医生新老客数据
export const registerVisitType = (params) => {
  return req.get('/report/doctor/statistics/register/order/visit_type', params);
}
// 挂号数据-查询医生新老客患者列表
export const registerVisitTypeList = (params) => {
  return req.get('/report/doctor/statistics/register/order/visit_type/list', params,'/api',{timeout: 3 * 1000});
}

//挂号数据-网诊统计
export const onlineOrder = (params) => {
  return req.get('/report/doctor/statistics/register/web/status', params);
}
//挂号数据-网诊明细列表
export const registerOnlineList = (params) => {
  return req.get('/report/doctor/statistics/register/web/status/list', params);
}
// 挂号数据-网诊统计医生新老客数据
export const onlineVisitType = (params) => {
  return req.get('/report/doctor/statistics/register/web/visit_type', params);
}
// 挂号数据-网诊查询医生新老客患者列表
export const onlineVisitTypeList = (params) => {
  return req.get('/report/doctor/statistics/register/web/visit_type/list', params);
}


// 获取业绩数据-门诊挂号统计
export const getOutpatientRegistrationStatistics = (params) => {
  return req.get('/report/doctor/statistic/performance/query/register', params);
}

// 获取业绩数据-网诊挂号统计
export const getOnlineRegistrationStatistics = (params) => {
  return req.get('/report/doctor/statistic/performance/query/web', params);
}

// 获取业绩数据-医生销售统计
export const getDoctorSalesStatistics = (params) => {
  return req.get('/report/doctor/statistic/performance/query/sale', params);
}


// 获取工作室数据-汇总统计
export const getStudioStatistics = (params) => {
  return req.get('/report/doctor/statistics/team/summary', params);
}

// 获取工作室数据-成员数据
export const getStudioMember = (params) => {
  return req.get('/report/doctor/statistics/team/member/list', params);
}
